import client from './AxiosClient'

const contactusService = {
    get : (params) => client.get("/contact-us", { params }),

}

export default contactusService;